import * as components from './components';

export default [
  {
        path: '/FAQ',
    component: components.FAQ,
        name: 'FAQ'
  }
];


// WEBPACK FOOTER //
// ./ClientApp/app/Faq/routes.js